module.exports = __webpack_public_path__ + "img/290-5585ae.png";